import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setTradeIn } from '../actions'
import Options from './Options'

const mapStateToProps = state => ({
  wizards: state.wizards,
  tradeIn: state.tradeIn,
  campaign: state.configuration.campaign,
  tradeInContext: state.configuration.tradeInContext
})

const mapDispatchToProps = {
  setWizards,
  setTradeIn
}

export default connect(mapStateToProps, mapDispatchToProps)(Options)
